import Vue from 'vue'
import Vuex from 'vuex'
import { Group } from '@/interfaces/Group'
import { MutationTypes } from '@/store/mutation-types'
import { GroupTag } from '@/interfaces/GroupTag'
import { ProductDetail } from '@/models/ProductDetail'

Vue.use(Vuex)

class State {
  loading = false
  currentStep = 0
  group: Group | null = null
  tag: GroupTag | null = null
  baseProductId: number | null = null;
}

export default new Vuex.Store({
  state: new State(),
  mutations: {
    [MutationTypes.CHANGE_CURRENT_STEP]: (state, payload: { currentStep: number; group?: Group; tag?: GroupTag; baseProductId?: number }) => {
      if (state.currentStep > payload.currentStep) {
        if (payload.currentStep === 0) {
          state.group = null
          state.tag = null
        }
        state.baseProductId = null
      }
      if (payload.group) {
        state.group = payload.group
      }

      if (payload.tag) {
        state.tag = payload.tag
      }

      state.baseProductId = payload.baseProductId ?? null

      state.currentStep = payload.currentStep
    },
    [MutationTypes.CHANGE_LOADING]: (state, payload: { loading: boolean }) => {
      state.loading = payload.loading
    }
  },
  actions: {
  },
  modules: {
  }
})
